import {Injectable} from "@angular/core";
import {environment} from "../../../../environments/environment";
import {Observable} from "rxjs/Observable";
import * as FileSaver from 'file-saver';
import {HttpClient, HttpResponse} from "@angular/common/http";
import {empty} from "rxjs/observable/empty";

import {SessionActions} from "../../../shared/actions";
import {MessageType} from "../../../shared/redux-store/session";
// Necessary to import the global printJS function
import {Configuration} from "print-js";

declare var printJS: (params: string | Configuration) => void;


@Injectable()
export class FileService {

  isSup = false;

  constructor(private http: HttpClient, private sessionActions: SessionActions) {

    if (this.detectIE() === false || this.detectIE() > 11) {
      this.isSup = true;
    } else {
      this.isSup = false;
    }

  }

  getPrivateFile(path: string): Observable<Blob> {

    if (!path || path == '') {
      return empty();
    }

    path = path.startsWith('http') ? path : environment.baseUrl + (path.startsWith('/') ? path : '/' + path);

    return this.http.get(path, {
      responseType: 'blob'
    });

  }

  base64toBlob(b64Data, contentType?: string, sliceSize?: number): Blob {

    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    let byteCharacters = atob(b64Data);
    let byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);

      let byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      let byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    let blob = new Blob(byteArrays, {type: contentType});
    return blob;

  }

  saveAs(data, filename: string) {
    FileSaver.saveAs(data, filename);
  }

  printFile(blobData: Blob | string, fileType: 'pdf' | 'image' | 'html' | 'json' = 'pdf', base64 = false) {

    const blobUrl = base64 == false ? URL.createObjectURL(blobData) : blobData;

    if (this.isSup) {
      printJS({
        printable: blobUrl,
        type: fileType,
        base64: base64
      });
    } else {
      this.sessionActions.pushMessage("Das direkte Drucken von PDF-Dateien wird von Ihrem Browser nicht unterstützt! Bitte nutzen Sie einen modernen Browser wie Edge, Firefox oder Chrome.", MessageType.WARNING, "PDF-Druck");
    }
  }

  /**
   * detect IE
   * returns version of IE or false, if browser is not Internet Explorer
   */
  detectIE() {
    let ua = window.navigator.userAgent;

    let msie = ua.indexOf('MSIE ');
    if (msie > 0) {
      // IE 10 or older => return version number
      return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    let trident = ua.indexOf('Trident/');
    if (trident > 0) {
      // IE 11 => return version number
      let rv = ua.indexOf('rv:');
      return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    let edge = ua.indexOf('Edge/');
    if (edge > 0) {
      // Edge (IE 12+) => return version number
      return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    // other browser
    return false;
  }

  public saveToFileSystem(response: HttpResponse<any>) {
    const contentDispositionHeader: string = response.headers.get('Content-Disposition');
    const parts: string[] = contentDispositionHeader.split(';');
    const filename = parts[1].split('=')[1];
    const blob = new Blob([response.body], {type: 'text/plain'});
    this.saveAs(blob, filename);
  }

  public saveResponseToFileSystem(response: HttpResponse<any>) {
    const contentDispositionHeader: string = response.headers.get('Content-Disposition');
    let filename = 'export';
    if (contentDispositionHeader) {
      const parts: string[] = contentDispositionHeader.split(';');
      filename = parts[1].split('=')[1];
    }
    const blob = new Blob([response.body], {type: 'text/plain'});
    this.saveAs(blob, filename);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/http/file.service.ts